import { __read, __spreadArray } from "tslib";
import { operate } from '../util/lift';
import { zip } from '../observable/zip';
export function zipWith() {
    var otherInputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherInputs[_i] = arguments[_i];
    }
    return operate(function (source, subscriber) {
        zip.apply(void 0, __spreadArray([source], __read(otherInputs), false)).subscribe(subscriber);
    });
}
//# sourceMappingURL=zipWith.js.map